export enum EBreakpoint {
  XS = 0,
  XM = 420,
  SM = 576,
  MD = 768,
  LG = 991,
  XL = 1200,
  XXL = 1500,
}
